// extracted by mini-css-extract-plugin
export default {"link":"SwapTxHash_link__H2uzo","active":"SwapTxHash_active__4XuAm"};